import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "../Login/Login.module.css";
import logo from "../../Assest/logo.png";
import hospital from "../../Assest/logo.jpeg";

import {
  FiMail,
  FiShield,
  FiTrendingUp,
  FiUsers,
  FiArrowLeft,
  FiCheckCircle,
} from "react-icons/fi";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    // Simple validation
    if (!email) {
      setError("Please enter your email address");
      setIsLoading(false);
      return;
    }

    // Simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      setIsLoading(false);
      return;
    }

    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
    }, 1500);
  };

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <img src={hospital} alt="Hospital" className={classes.bgImage} />
        <div className={classes.overlay}></div>

        <div className={classes.leftContent}>
          <div className={classes.logoRow}>
            <img src={logo} alt="logo" className={classes.logo} />
            <div>
              <h2>City Care Hospital</h2>
              <span>Hospital Management System</span>
            </div>
          </div>

          <div className={classes.hero}>
            <h1>
              Better Care.
              <br />
              Smarter Management.
            </h1>
            <div className={classes.line}></div>
            <p>
              Streamline your hospital operations and
              deliver exceptional patient care with our
              comprehensive management system.
            </p>
          </div>

          <div className={classes.featureCard}>
            <div className={classes.feature}>
              <div className={classes.icon}>
                <FiShield />
              </div>
              <div>
                <h4>Secure & Compliant</h4>
                <p>HIPAA compliant with enterprise-level security</p>
              </div>
            </div>

            <div className={classes.feature}>
              <div className={classes.icon}>
                <FiTrendingUp />
              </div>
              <div>
                <h4>Real-time Analytics</h4>
                <p>Make informed decisions with live reporting</p>
              </div>
            </div>

            <div className={classes.feature}>
              <div className={classes.icon}>
                <FiUsers />
              </div>
              <div>
                <h4>Patient Centered</h4>
                <p>Enhance patient experience and quality care</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.right}>
        <div className={classes.loginCard}>
          {!isSubmitted ? (
            <>
              <button
                className={classes.backBtn}
                onClick={handleBackToLogin}
              >
                <FiArrowLeft />
                Back to Sign In
              </button>

              <h1>Forgot Password?</h1>
              <p className={classes.subtitle}>
                No worries! Enter your email address and we'll send you a link to reset your password.
              </p>

              {error && <div className={classes.errorMessage}>{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className={classes.formGroup}>
                  <label>Email Address</label>
                  <div className={classes.input}>
                    <FiMail className={classes.inputIcon} />
                    <input
                      type="email"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className={classes.loginBtn}
                  disabled={isLoading}
                >
                  {isLoading ? "Sending..." : "Send Reset Link"}
                </button>
              </form>

              <div className={classes.divider}>
                <span></span>
                <p>or</p>
                <span></span>
              </div>

              <div className={classes.contact}>
                <span>Contact Administrator</span>
              </div>

              <div className={classes.signInLink}>
                Remember your password?{" "}
                <button
                  className={classes.signInBtn}
                  onClick={handleBackToLogin}
                >
                  Sign In
                </button>
              </div>
            </>
          ) : (
            <>
              <div className={classes.successContainer}>
                <div className={classes.successIcon}>
                  <FiCheckCircle />
                </div>
                <h1>Check Your Email</h1>
                <p className={classes.subtitle}>
                  We've sent a password reset link to
                  <br />
                  <strong>{email}</strong>
                </p>
                <p className={classes.successMessage}>
                  Please check your inbox and follow the instructions to reset your password.
                </p>
                <button
                  className={classes.loginBtn}
                  onClick={handleBackToLogin}
                >
                  Back to Sign In
                </button>
              </div>
            </>
          )}
        </div>

        <p className={classes.footer}>
          © 2024 City Care Hospital. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;